"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3878],{

/***/ 65509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ FactoryCookie; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50853);
/* harmony import */ var _kernel_Environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24880);




var FactoryCookie = /*#__PURE__*/ function() {
    "use strict";
    function FactoryCookie(config) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, FactoryCookie);
        this.config = config;
    }
    var _proto = FactoryCookie.prototype;
    _proto.cookie = function cookie() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
            var isNode, _tmp;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isNode = _kernel_Environment__WEBPACK_IMPORTED_MODULE_3__/* .Environment.create */ .q.create().isNode();
                        if (!isNode) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            __webpack_require__.e(/* import() */ 5107).then(__webpack_require__.t.bind(__webpack_require__, 15107, 23))
                        ];
                    case 1:
                        _tmp = _state.sent().NodeCookie.create({
                            config: _this.config
                        });
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            __webpack_require__.e(/* import() */ 9351).then(__webpack_require__.bind(__webpack_require__, 39351))
                        ];
                    case 3:
                        _tmp = _state.sent().WindowCookie.create({
                            config: _this.config
                        });
                        _state.label = 4;
                    case 4:
                        return [
                            2,
                            _tmp
                        ];
                }
            });
        })();
    };
    FactoryCookie.create = function create(param) {
        var config = param.config;
        return new FactoryCookie(config);
    };
    return FactoryCookie;
}();


/***/ }),

/***/ 33878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ GetCurrentLoginStatusAuthUseCase; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_cookie/FactoryCookie.ts
var FactoryCookie = __webpack_require__(65509);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(64297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 2 modules
var _create_super = __webpack_require__(39309);
// EXTERNAL MODULE: ../../node_modules/zod/v3/types.js + 1 modules
var types = __webpack_require__(53538);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/architecture.ts
var architecture = __webpack_require__(70163);
;// CONCATENATED MODULE: ../../packages/stayforlong/src/auth/domain/LoginStatus.ts





var LoginStatusValidation = types/* object */.Ry({
    value: types/* boolean */.O7({
        required_error: "[LoginStatus] value is required"
    })
});
var LoginStatus = /*#__PURE__*/ function(Model) {
    "use strict";
    (0,_inherits/* default */.Z)(LoginStatus, Model);
    var _super = (0,_create_super/* default */.Z)(LoginStatus);
    function LoginStatus(_value) {
        (0,_class_call_check/* default */.Z)(this, LoginStatus);
        var _this;
        _this = _super.call(this);
        _this._value = _value;
        return _this;
    }
    var _proto = LoginStatus.prototype;
    _proto.isLogged = function isLogged() {
        return this._value === true;
    };
    _proto.isUnlogged = function isUnlogged() {
        return this._value === false;
    };
    LoginStatus.create = function create(param) {
        var value = param.value;
        LoginStatusValidation.parse({
            value: value
        });
        return new LoginStatus(value);
    };
    LoginStatus.logged = function logged() {
        return LoginStatus.create({
            value: true
        });
    };
    LoginStatus.unlogged = function unlogged() {
        return LoginStatus.create({
            value: false
        });
    };
    return LoginStatus;
}(architecture/* Model */.H);

;// CONCATENATED MODULE: ../../packages/stayforlong/src/auth/infrastructure/CookieAuthRepository.ts






var CookieAuthRepository = /*#__PURE__*/ function() {
    "use strict";
    function CookieAuthRepository(config) {
        (0,_class_call_check/* default */.Z)(this, CookieAuthRepository);
        this.config = config;
    }
    var _proto = CookieAuthRepository.prototype;
    _proto.checkLoginStatus = function checkLoginStatus() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var cookie, ref, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            FactoryCookie/* FactoryCookie.create */.f.create({
                                config: _this.config
                            }).cookie()
                        ];
                    case 1:
                        cookie = _state.sent();
                        ref = (0,_sliced_to_array/* default */.Z)(cookie.get({
                            key: "sfl_user"
                        }), 1), error = ref[0];
                        if (error) return [
                            2,
                            LoginStatus.unlogged()
                        ];
                        return [
                            2,
                            LoginStatus.logged()
                        ];
                }
            });
        })();
    };
    CookieAuthRepository.create = function create(param) {
        var config = param.config;
        return new CookieAuthRepository(config);
    };
    return CookieAuthRepository;
}();

;// CONCATENATED MODULE: ../../packages/stayforlong/src/auth/application/GetCurrentLoginStatusAuthUseCase.ts




var GetCurrentLoginStatusAuthUseCase = /*#__PURE__*/ function() {
    "use strict";
    function GetCurrentLoginStatusAuthUseCase(config, repository) {
        (0,_class_call_check/* default */.Z)(this, GetCurrentLoginStatusAuthUseCase);
        this.config = config;
        this.repository = repository;
    }
    var _proto = GetCurrentLoginStatusAuthUseCase.prototype;
    _proto.execute = function execute() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    _this.repository.checkLoginStatus()
                ];
            });
        })();
    };
    GetCurrentLoginStatusAuthUseCase.create = function create(param) {
        var config = param.config, repository = param.repository;
        return new GetCurrentLoginStatusAuthUseCase(config, repository !== null && repository !== void 0 ? repository : CookieAuthRepository.create({
            config: config
        }));
    };
    return GetCurrentLoginStatusAuthUseCase;
}();
GetCurrentLoginStatusAuthUseCase.USE_CASE_NAME = "GetCurrentLoginStatusAuthUseCase";



/***/ })

}]);